<template>
  <sui-segment>
	<!-- <v-btn @click.prevent="handleClickAdd">Add</v-btn> -->
    <DataTable :key="updateTable"
              uri="groups"
              searchable
              long
			  create
              :options="tableOptions"
			  v-on:clickCreate="handleClickAdd"
			  v-on:clickEdit="handleClickEdit"
              v-on:clickRow="callbackClickRow"
              v-on:clickRemove="callbackClickRemove" />

	<sui-modal v-model="showModal">
      <sui-modal-header>{{mode == "create" ? $t("createGroup") : $t("editGroup")}}</sui-modal-header>
      <sui-modal-content  scrolling image>
        <sui-modal-description>
            
             <v-text-field 
             :label="$t('name')"
             v-model="current.name"></v-text-field>             
			 
			 <v-row>
				 <v-col cols="12" md=6>
					 <v-color-picker
			 v-model="current.color"
			 elevation="15"
			></v-color-picker></v-col>
				 <v-col cols="12" md=6>
             <v-select
			 v-if="mode=='create'"
			 :label="$t('admin')"
			 :items="userDropdown"
			 item-text="value"
			 clearable
          	 item-value="key"
			 v-model="current.admin">
			 </v-select>
			 </v-col>
			 </v-row>
        </sui-modal-description>
      </sui-modal-content>
      <sui-modal-actions>
        <sui-button positive @click.native="handleSaveGroup">
          {{$t('save')}}
        </sui-button>
      </sui-modal-actions>
    </sui-modal>


  </sui-segment>
</template>

<script>

import DataTable from '@/components/DataTable.vue';
import ApiService from "@/services/ApiService.js"
export default {
  components: {
    DataTable
  },
  name: 'Groups',
  data(){
    return {
        updateTable: 0,
        tableOptions: {
          columns: [
            // { label: this.$t('public'), name: 'is_public', width: 2, render: function (val, row) { return '<i class="ui ' + (val ? 'check' : 'times')+' icon"></i>' }},
            {label: this.$t('name'), name: 'name' },
            {label: this.$t("members"), name: "member_amount", canzero: true},
             {label: this.$t("admins"), name: "admin_amount", canzero: true},
             {label: this.$t("color"), name: "color", color: true},
            // {label: this.$t("landingpage"), name: "landingpage_id", landingpage: true}, //, render: function(val) { landingpages.find(page => page.id == val).name }
            {label: this.$t('createdAt'), name: 'created_at', time:true },
			{label: this.$t("actions"), name: "actions", sortable: false}
          ],
          search: '',
          start: 0,
          limit: 10,
          sortKey: 'id',
          sortAs: "asc",
        },
		noClick:false,
		current: {},
		showModal: false,
		userDropdown: [],
		mode: "create",
    }
  },
  async created(){
	  let res = await ApiService.getUserDropdown();
        for(let [key, value] of Object.entries(res.data)){
			this.userDropdown.push({key:key, value:value})
		}
  },
  methods: {
	  async handleClickAdd(){
		  this.mode = "create"
		  this.current = {}
		  this.current.color = this.randomColor()
		  this.showModal = true;
	  },
	  async handleClickEdit(row){
			  this.$router.push("/management/group/" + row.id + "?edit=true")
		//   this.mode = "edit"
		//   this.noClick = true;
		//   this.current = row
		//   this.showModal = true;
		//   this.noClick = false;
	  },
	   randomColor() {
		let color = '#';
		for (let i = 0; i < 6; i++){
			const random = Math.random();
			const bit = (random * 16) | 0;
			color += (bit).toString(16);
			}
		return color;
		},
	  callbackClickRow(row){
		  if(this.noClick == false && this.showModal == false){
			  this.$router.push("/management/group/" + row.id)
		  }
	  },
	  async handleSaveGroup(){
		  this.current.color == null ? this.current.color = "#e0e0e0" : ""
		  this.current.color.hex != null ? this.current.color = this.current.color.hex : ""
		  if(this.mode == "create"){
		  let res = await ApiService.postGroup(this.current)
		  if(res.status == 201){
			  this.showModal = false
			  this.updateTable++
			  this.$swal({
				  icon: "success",
				  title: this.$t("success"),
				  text: this.$t("created")
			  })
		  }else{
			  this.$swal({
				  icon: "error",
				  title: this.$t("error"),
				  text: this.$t(res.data.message || res.data)
			  })
		  }
		  }else{
			console.log(this.current)
			  let res = await ApiService.putGroup(this.current.id, {name: this.current.name, color: this.current.color})
		  if(res.status == 200){
			  this.showModal = false
			  this.updateTable++
			  this.$swal({
				  icon: "success",
				  title: this.$t("success"),
				  text: this.$t("edited")
			  })
		  }else{
			  this.$swal({
				  icon: "error",
				  title: this.$t("error"),
				  text: this.$t(res.data.message || res.data)
			  })
		  }
		  }
	  },
	  async callbackClickRemove(row){
		  this.noClick = true;
		  let self = this
		this.$swal.fire({
			icon: "warning",
			title: this.$t("areYouSure"),
			text: this.$t("youCantRevert"),
			showCancelButton: false,
			showDenyButton: true,
			confirmButtonText: this.$t('yesDelete'),
			denyButtonText: this.$t("noKeep")
			}).then(async(result) => {
		  	self.noClick = false;
			if (result.isConfirmed) {
				let res = await ApiService.deleteGroup(row.id);
				if (res===false) {
			  		this.updateTable++
					  this.$swal({
						  icon: "success",
						  title: this.$t("deleted"),
						  text: this.$t("deleteSuccess")
					  })
				}
			}
		})
	  }
  }
}
</script>
